import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const heroBox = document.querySelector('.hero-box');

if (heroBox) {
    ScrollTrigger.matchMedia({
        '(min-width: 1024px)': function() {
            gsap.from(heroBox, {
                y: 40,
                opacity: 0,
                duration: 0.8,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: heroBox,
                    start: 'top 75%',
                    end: 'top 75%',
                    toggleActions: 'play none reverse none'
                }
            });
        }
    });
}
